import { Injectable } from "@angular/core";

import { IContractData, IContractEditData, Matcher } from "./IContractData";
import { IServiceAdapter } from "./IServiceAdapter";
import { NpmServiceAdapter } from "./NpmServiceAdapter";
import { XBidServiceAdapter } from "./XBidServiceAdapter";
import {NpmBackupServiceAdapter} from "./NpmBackupServiceAdapter";
import {ContractState} from "../ContractDataModels";

@Injectable()
export class ContractDataService {
   private readonly matcherServiceAdapters: { [matcher: string]: IServiceAdapter<any> } = {};

    activeMatcher: Matcher = Matcher.NPM;
    constructor(
        npmServiceAdapter: NpmServiceAdapter,
        xBidServiceAdapter: XBidServiceAdapter,
        npmBackupServiceAdapter: NpmBackupServiceAdapter
    ) {
        this.matcherServiceAdapters[Matcher.NPM] = npmServiceAdapter;
        this.matcherServiceAdapters[Matcher.XBID] = xBidServiceAdapter;
        this.matcherServiceAdapters[Matcher.Backup] = npmBackupServiceAdapter;
    }

    getContractsByMatcher(matcher: Matcher): Promise<IContractData[]> {
        return this.matcherServiceAdapters[matcher].getContracts();
    }

    saveByMatcher(changedContractAreas: IContractEditData[], marketAreaCodes: string[], matcher: Matcher): Promise<IContractData[]> {
        return this.matcherServiceAdapters[matcher].save(changedContractAreas, marketAreaCodes);
    }

    save(changedContractAreas: IContractEditData[], marketAreaCodes: string[]): Promise<IContractData[]> {
        return this.matcherServiceAdapters[this.activeMatcher].save(changedContractAreas, marketAreaCodes);
    }

    contractManagementRequestByMatcher(action: ContractState, matcher: Matcher): Promise<any> {
        return this.matcherServiceAdapters[matcher].contractManagementRequest(action);
    }

    contractManagementRequestByAction(action: ContractState): Promise<any> {
        return this.matcherServiceAdapters[this.activeMatcher].contractManagementRequest(action);
    }
    isContractStatusEditable(status: string): boolean {
        return this.matcherServiceAdapters[this.activeMatcher].isContractStatusEditable(status);
    }

    get availableActions() {
        return this.matcherServiceAdapters[this.activeMatcher].availableActions;
    }

    contractManagementRequest(action: ContractState): Promise<any> {
        return Promise.resolve();
    }
}



// WEBPACK FOOTER //
// ./src/app/ContractManagement/Services/ContractDataService.ts